import React from 'react';

import { default as ReactSelect } from 'react-select';

class Select extends React.Component {
    render() {
        return (
            <div data-testid={this.props['data-testid']}>
                <ReactSelect clearable={false} {...this.props} />
            </div>
        );
    }
}

export default Select;
